// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e05a6b37","970":"6673ac4b"}[chunkId] + ".chunk.js";
};